import { render } from "./MandantenApp.vue?vue&type=template&id=a0b5ce20"
import script from "./MandantenApp.vue?vue&type=script&lang=js"
export * from "./MandantenApp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__